<template>
  <div class="sidebar-menu-link">
    <router-link :to="linkTo" :title="title">
      <i class="icon" :class="iconName"></i>
    </router-link>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SidebarLink',
  props: [
    'linkTo',
    'title',
    'iconName'
  ],
  components: {}
})
class SidebarLink extends Vue {
  @Prop linkTo
  @Prop title
  @Prop iconName
}

export default SidebarLink
</script>

<style scoped lang="less">
@import '../../assets/less/globals';

.sidebar-menu-link {
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
  flex: 1;
  max-height: 25%;

  text-align: center;

  .icon {
    color: white;
    font-size: 30px;
  }

  a {
    z-index: 10;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 100%;
  }

  &:hover .icon {
    color: white;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;

    height: 100%;
    width: 100%;;

    background-color: var(--color-hover);
    opacity: 0;

    transition: opacity 0.4s ease-in-out;
  }

  &:hover::before {
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }

  a::after {
    color: white;
    font-size: 30px;
    margin-left: var(--margin--medium);

    content: attr(title);
  }
}


@media screen and (min-width: @screen-desktop-low) {
  .sidebar-menu-link a {
    width: 100%;

    &::after {
      display: none;
    }
  }

  .sidebar-menu-link a::after {
    position: absolute;
    left: 100%;

    display: none;
    margin-left: 0;
    padding: 20px;

    font-size: 20px;
    white-space: nowrap;

    background-color: var(--color-hover);

    content: attr(title);
    opacity: 0;
    transition: all 0.4s ease;
  }

  .sidebar-menu-link a:hover::after {
    display: block;
    opacity: 1;
  }
}
</style>
